'use strict';
angular.module('infotypeModule', []).controller('createInfotypeCtrl', function($scope, $modalInstance,trsspliceString, commandService) {
    $scope.types = [];
    $scope.isShowKeywordTips = false;
    $scope.okToSubmit = false;
    $scope.close = function() {
        $modalInstance.dismiss();
    };
    $scope.submit = function() { 
        var typename=trsspliceString.getValuesBykey($scope.types, 'name').join(',');
        commandService.infoinvoke('saveInfoType', {InfoType:typename}).then(
            function(data) {
                $modalInstance.close(data)
        });
    };
    //初始化函数
    $scope.invalidTag = function(tag) {
        var reg = /^[^<>\/]*$/;
        if (tag.name.length > 50) {
            $scope.isShowKeywordTips = true;
            $scope.keywordsTips = "单个关键词长度不能超过50";
        }
        if (!reg.test(tag.name)) {
            $scope.isShowKeywordTips = true;
            $scope.keywordsTips = "不能包含特殊字符";
        }
    };
    $scope.checkTag = function(tag) {
        var len = $scope.types.length;
        /*if (len == 10) {
            $scope.isShowKeywordTips = true;
            $scope.keywordsTips = "关键词个数不能超过10个";
            return false;
        } else {
            $scope.keywordsTips = "";
            $scope.isShowKeywordTips = false;
        }*/
        if (tag.name.indexOf(" ") > -1) {
            var spaceArr = tag.name.split(" ");
            $timeout(function() {
                $scope.types.pop();
                var containArr = [];
                for (var j = 0; j < $scope.types.length; j++) {
                    containArr.push($scope.types[j].name);
                }
                for (var i = 0; i < spaceArr.length; i++) {
                    if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                        $scope.types.push({ 'name': spaceArr[i] });
                        containArr.push(spaceArr[i]);
                    }
                }
            })
        }
    };
    $scope.leave = function() {
        $scope.isShowKeywordTips = false;
        if($scope.types.length<=0){
            $scope.okToSubmit = false;
        }else{
            $scope.okToSubmit = true;
        }
    };
    $scope.enter = function() {
        var reg = /^[^<>\/]*$/;
        if (angular.isDefined($scope.typesStr) && (!reg.test($scope.typesStr) || $scope.typesStr.length > 50)) {
            $scope.isShowKeywordTips = true;
            $scope.okToSubmit = false;
        }else{
            $scope.okToSubmit = true;
        }
        if($scope.types.length<=0){
            $scope.okToSubmit = false;
        }else{
            $scope.okToSubmit = true;
        }
    }
}).controller('editInfotypeCtrl', function($scope, $modalInstance,trsspliceString, commandService,type) {
    $scope.typename = type.VALUE;
    $scope.close = function() {
        $modalInstance.dismiss();
    };
    $scope.submit = function() {  
        commandService.infoinvoke('editInfoType', {InfoTypeId:type.INFORTYPEID,InfoType:$scope.typename}).then(
            function(data) {
                $modalInstance.close(data)
        });
    }
});
